import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Checkbox, ThemeProvider } from '@volkswagen-onehub/components-core';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-vwsa-checkbox',
    template: ''
})
export class VWSACheckboxComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://lsg-auth.prodworksngwsa.de/components-core/?path=/docs/components-checkbox--checkbox
    @Input() label = '';
    @Input() checked = false;
    @Output() checkedChange = new EventEmitter<boolean>();

    ElementToShow = () => (
        <ThemeProvider>
            <Checkbox
                value={this.checked.toString()}
                label={this.label}
                checked={this.checked}
                onChange={this.handleChange} />
        </ThemeProvider>
    );

    constructor(private hostRef: ElementRef) {
        this.handleChange = this.handleChange.bind(this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.render();
    }

    ngAfterViewInit(): void {
        this.render();
    }

    ngOnDestroy(): void {
        //removing this for now because it causes delays when navigating.
        //find a way to call it async so it doesn't delay navigation
        //or change the navigation so pages are preloaded and also not destructed.
        //ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }

    public handleChange(event: any) {
        //console.log('handleChange');
        this.checked = !this.checked;
        //console.log(this.checked);
        this.checkedChange.emit(this.checked);
        this.render();
    }
}
